export const FILTER_NAMES = {
  COMMON_FILTERS: 'commonFilters',
  PEOPLE_COMPARE_FILTERS: 'peopleCompareFilters',
  DATE_COMPARE_FILTER: 'dateCompareFilter',
  CURRENT_FILTERS: 'currentFilters',
  PREVIOUS_FILTERS: 'previousFilters',
};
